import { useMutation } from '@tanstack/react-query'
import { createFeedback, type CreateFeedbackPayload, type CreateFeedbackResponse } from './api'

/**
 * React Query mutation for POST /api/v1/feedback.
 *
 * On success, callers should show a confirmation toast and close the modal.
 * Errors propagate via the existing global MutationCache handler in main.tsx
 * (which toasts "Something went wrong"); no per-call error handling needed.
 */
export function useFeedbackSubmit() {
  return useMutation<CreateFeedbackResponse, Error, CreateFeedbackPayload>({
    mutationFn: createFeedback,
  })
}
